import React from "react";
import { Button, Modal } from "reactstrap";

export const RemoveFee = ({ open, onCancel, onSubmit }) => {
  return (
    <Modal isOpen={open} toggle={onCancel}>
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Премахване на такса
        </h5>
        <button
          type="button"
          onClick={onCancel}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <h5>Искаш ли да премахнеш тази такса за транзакция?</h5>
      </div>
      <div className="modal-footer">
        <Button
          type="button"
          color="secondary"
          onClick={onCancel}
          className="waves-effect"
          data-dismiss="modal"
        >
          Отказ
        </Button>
        <Button
          color="danger"
          type="button"
          onClick={() => {
            if (!onSubmit) {
              console.log("Submit not provided");
            }
            onSubmit();
          }}
          className="waves-effect waves-light"
        >
          Да
        </Button>
      </div>
    </Modal>
  );
};

export default RemoveFee;
